class CAREERS_VIDEOS {
  constructor(selector) {
    this.container = selector || '.video_carousel';
    this.video_wrapper = this.getVideoWrapper();
    this.video_thumbs = this.getVideoThumbs();
    this.player = null;
    this.current_id = this.getFirstVideoID();
    this.video_job_title = false;
    this.loadYoutubeAPI();
    this.attachEvents();
  }

  attachEvents() {
    Array.from(this.video_thumbs).forEach((el, idx) => {
      let $idx = idx;
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.current_id = el.dataset.youtubeid;
        this.video_job_title = el.dataset.jobtitle;
        this.loadVideo();
        this.setActiveThumb($idx);
      });
    });
  }

  getVideoWrapper() {
    return document.querySelector(this.container);
  }
  getVideoThumbs() {
    return this.video_wrapper.querySelectorAll('.thumb');
  }

  getFirstVideoID() {
    return this.video_thumbs[0].dataset.youtubeid;
  }

  setActiveThumb(idx = 0) {
    Array.from(this.video_thumbs).forEach((el) => {
      el.classList.remove('active');
    });
    return this.video_thumbs[idx].classList.add('active');
  }

  loadYoutubeAPI() {
    if (typeof YT == 'undefined') {
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    } else {
      onYouTubeIframeAPIReady();
    }
  }

  onYouTubeIframeAPIReady() {
    if (typeof $player !== 'object') {
      this.player = new YT.Player('player', {
        height: '315',
        width: '560',
        videoId: this.current_id,
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onPlayerStateChange,
        },
        playerVars: {
          rel: 0,
          modestbranding: 1,
          color: 'white',
        },
      });
      this.setActiveThumb();
    }
  }

  onPlayerReady(event) {
    event.target.setVolume(50);
  }

  onPlayerStateChange(event) {}
  stopVideo() {
    $player.stopVideo();
  }

  loadVideo() {
    if (dataLayer) {
      dataLayer.push({
        event: 'videoChange',
        videoJobTitle: this.video_job_title,
      });
    }
    this.player.loadVideoById({
      videoId: this.current_id,
    });
  }
}

window.addEventListener('DOMContentLoaded', (event) => {
  window.$CAREERS_VIDEOS = new CAREERS_VIDEOS();
  window.onYouTubeIframeAPIReady = () => {
    window.$CAREERS_VIDEOS.onYouTubeIframeAPIReady();
  };
});
